import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'
import { Score } from '../types/score'
import { ScoreView } from './score_view'

export const ScoreSection = ({score, highscore} : {score: Score, highscore: Score}) => (
	<div className={mergeStyles({
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 24,
	})}>
		<ScoreView name={'Session'} score={score} />
		<ScoreView name={'Best'} score={highscore} />
	</div>
)